import React, { VFC, useContext, useMemo } from 'react'
import { LanguageContext } from '../../../../hocs'
import { DatePickerInput } from 'rc-datepicker'
import styles from './DateRangePicker.module.css'
import cn from 'classnames'

type Props = {
  className?: string
  dateDelimiterClass?: string
  dateItemClass?: string
  displayFormat?: string
  startDate: Date
  endDate: Date
  onStartDateChange?: (date: Date) => void
  onEndDateChange?: (date: Date) => void
  responsive?: boolean
}

export const DateRangePicker: VFC<Props> = ({
  className,
  dateItemClass,
  dateDelimiterClass,
  displayFormat = 'DD.MM.YYYY',
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  responsive = true
}) => {
  const { language, getLocale } = useContext(LanguageContext)
  const currentLocale = getLocale(language)

  return (
    <div
      className={cn(styles.root, className, {
        [styles.responsive]: responsive
      })}
    >
      <div className={cn(styles.item, dateItemClass)}>
        {useMemo(
          () => (
            <DatePickerInput
              className={styles.datepicker}
              locale={currentLocale}
              onChange={onStartDateChange}
              maxDate={endDate}
              displayFormat={displayFormat}
              value={startDate}
            />
          ),
          [endDate, startDate, currentLocale]
        )}
      </div>

      <div className={cn(styles.delimiter, dateDelimiterClass)}>
        <small>—</small>
      </div>

      <div className={cn(styles.item, dateItemClass)}>
        {useMemo(
          () => (
            <DatePickerInput
              className={styles.datepicker}
              locale={currentLocale}
              displayFormat={displayFormat}
              minDate={startDate}
              onChange={onEndDateChange}
              value={endDate}
            />
          ),
          [endDate, startDate, currentLocale]
        )}
      </div>
    </div>
  )
}
